import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ContactsSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const ContactsSearch = ({ searchTerm, setSearchTerm }: ContactsSearchProps) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input
          type="text"
          placeholder={t("companies.contacts.searchPlaceholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
};
